import { z } from 'zod';
export const candleSchema = z.object({
    time: z.number().int().nonnegative(),
    open: z.number().finite().positive(),
    high: z.number().finite().positive(),
    low: z.number().finite().positive(),
    close: z.number().finite().positive(),
    tickVolume: z.number().int().nonnegative(),
    spread: z.number().int().nonnegative(),
    realVolume: z.number().nonnegative(),
});
/**
 * Structural sanity check.
 *
 * The exporter appends to text files that can be read mid-write, so a tail read
 * can catch a torn line. Rows that fail this are dropped and counted, never
 * ingested — a bar whose high is below its low would silently corrupt every
 * indicator built on it.
 */
export function isCoherentCandle(c) {
    return (Number.isFinite(c.open) &&
        Number.isFinite(c.high) &&
        Number.isFinite(c.low) &&
        Number.isFinite(c.close) &&
        c.open > 0 &&
        c.low > 0 &&
        c.high >= c.low &&
        c.high >= c.open &&
        c.high >= c.close &&
        c.low <= c.open &&
        c.low <= c.close);
}
/** Price series selectors used by indicators and rules. */
export const series = {
    open: (c) => c.open,
    high: (c) => c.high,
    low: (c) => c.low,
    close: (c) => c.close,
    hl2: (c) => (c.high + c.low) / 2,
    hlc3: (c) => (c.high + c.low + c.close) / 3,
    ohlc4: (c) => (c.open + c.high + c.low + c.close) / 4,
    volume: (c) => c.tickVolume,
};
export const priceSourceSchema = z.enum(Object.keys(series));
//# sourceMappingURL=candle.js.map